import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19.97 21H14v-3l1-4H6V3h6v6h5c1.1 0 2 .9 2 2l-2 7h2.97v3zM5 15V3H3v14h9v-2H5z"
}), 'AirlineSeatLegroomReducedSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/AirlineSeatLegroomReducedSharp.js
// module id = 1960
// module chunks = 2